import Logo1 from 'src/newSrc2/assets/svg/sclen_collapse.png';

import './LogoLoader.css';

/**
 * LogoLoader — company-logo centered inside a rotating orbital dot.
 *
 * Props
 * ─────
 * size        {number}  Logo box size in px (default 80).
 * orbitColor  {string}  Orbit ring + dot color (default '#4F46E5').
 * dotSize     {number}  Dot diameter in px (default 10).
 * loadingText {string}  Optional text rendered below the orbit.
 * className   {string}  Extra classes on the root element.
 */
const LogoLoader = ({
  size = 80,
  orbitColor = '#4F46E5',
  dotSize = 10,
  loadingText = '',
  className = '',
}) => {
  /* Orbit circle is 80 % larger than the logo so the dot clears the logo edge */
  const orbitSize = Math.round(size * 1.8);

  return (
    <div
      role='status'
      aria-label='Loading'
      className={`logo-loader-root ${className}`}
    >
      <div
        className='logo-loader-container'
        style={{ width: orbitSize, height: orbitSize }}
      >
        {/* Static orbit ring */}
        <div
          className='logo-orbit-ring'
          style={{ borderColor: `${orbitColor}33` /* 20 % opacity */ }}
        />

        {/* Rotating arm — carries the dot around the ring */}
        <div
          className='logo-orbit-arm'
          style={{ width: orbitSize, height: orbitSize }}
        >
          <div
            className='logo-orbit-dot'
            style={{
              width: dotSize,
              height: dotSize,
              backgroundColor: orbitColor,
              boxShadow: `0 0 8px 2px ${orbitColor}66`,
            }}
          />
        </div>

        {/* Company logo — fixed at center, never rotates */}
        <img
          src={Logo1}
          alt='Company logo'
          className='logo-loader-img'
          style={{ width: size * 0.65, height: size * 0.65 }}
          draggable={false}
        />
      </div>

      {loadingText && <p className='logo-loader-text'>{loadingText}</p>}
    </div>
  );
};

export default LogoLoader;
